import { render } from "./TableroRouter.vue?vue&type=template&id=16d9fde3&scoped=true"
import script from "./TableroRouter.vue?vue&type=script&lang=js"
export * from "./TableroRouter.vue?vue&type=script&lang=js"

import "./TableroRouter.vue?vue&type=style&index=0&id=16d9fde3&scoped=true&lang=css"

import exportComponent from "/var/www/adm3.argusblack/adm3.argusblack/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16d9fde3"]])

export default __exports__